import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Spinner
} from '../../../config/react'
import UserProvider from '../../../config/UserContext'
import Select from 'react-select'
const AddUser = () => {
  const user = useContext(UserProvider)
  console.log(user.id)
  const urlParams = useParams()
  const history = useHistory()
  const [IsShowPassword, setIsShowPassword] = useState(false)
  const [IsShowConfirmPassword, setIsShowConfirmPassword] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const submitbtnRef = useRef()
  const validator = useRef(new SimpleReactValidator())
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [Roles, setRoles] = useState([])
  const DefaultInputs = {
    id: 0,
    email: '',
    name: '',
    password: '',
    confirm_password: '',
    is_active: 0,
    roleids: []
  }
  const [Inputs, setInputs] = useState(DefaultInputs)
  const [DuplicateInputs, setDuplicateInputs] = useState([])

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AddUser
    GetRoles()
    if (urlParams.id != null) {
      document.title = Title.EditUser
      GetUser()
    }
  }, [urlParams.id])

  const GetUser = () => {
    const param = {
      _id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetUser, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const roleids =
          response.data.result[0][0].role_ids != null
            ? response.data.result[0][0].role_ids.split(',')
            : []
        if (roleids.length > 0) {
          const roleIds = roleids.map((x) => parseInt(x))
          response.data.result[0][0].roleids = roleIds
        }
        response.data.result[0][0].password = ''
        setInputs(response.data.result[0][0])
        setDuplicateInputs(response.data.result[0][0])
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const GetRoles = () => {
    const param = {
      _page: 1,
      _search: '',
      _page_size: 10,
      _sort_column: '',
      _sort_direction: ''
    }
    setLoading(true)
    HttpService.postApi(API.GetRoles, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const roles = []
        response.data.result[1].map((item, index) => {
          roles.push({ label: item.name, value: item.id })
          return true
        })
        setRoles(roles)
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const handleInputChanges = (event, fieldName) => {
    if (fieldName === 'is_active') setInputs({ ...Inputs, [fieldName]: event.target.checked })
    else if (fieldName === 'roleids')
      setInputs({ ...Inputs, [fieldName]: Array.isArray(event) ? event.map((x) => x.value) : [] })
    else setInputs({ ...Inputs, [fieldName]: event.target.value })
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    if (submitbtnRef.current) submitbtnRef.current.setAttribute('disabled', 'disabled')

    const param = {
      _id: Inputs.id,
      _name: Inputs.name.trim(),
      _email: Inputs.email,
      _password: Inputs.password,
      _is_active: Inputs.is_active ? 1 : 0,
      _role_ids: Inputs.roleids
    }
    setLoading(true)
    HttpService.postApi(API.SetUser, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        submitbtnRef.current.removeAttribute('disabled')
        return
      }
      if (urlParams.id == null) toast.success(Messages.RecordAdded)
      else toast.success(Messages.RecordUpdated)
      setForceUpdate(!isForceUpdate)
      if (user.id === parseInt(urlParams.id)) {
        if (
          DuplicateInputs.name.trim() === Inputs.name.trim() &&
          DuplicateInputs.email === Inputs.email &&
          Inputs.password === '' &&
          DuplicateInputs.is_active === Inputs.is_active
        ) {
          history.push('/users')
        } else {
          localStorage.removeItem('appState')
          localStorage.removeItem('PermissionList')
          window.history.pushState(null, '', '/login')
          window.history.replaceState(null, '', '/login')
          window.location.href = '/login'
        }
      } else {
        history.push('/users')
      }
    })
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id == null ? Title.AddUser : Title.EditUser}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form
                className="forms-sample"
                autoComplete="off"
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Username</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={(e) => handleInputChanges(e, 'name')}
                        value={Inputs.name}
                      />
                      {validator.current.message(
                        'Name',
                        Inputs.name,
                        'required|alpha_num_space|max:255',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        onChange={(e) => handleInputChanges(e, 'email')}
                        value={Inputs.email}
                      />
                      {validator.current.message('Email', Inputs.email, 'required|email|max:50', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Password</label>
                      <input
                        type={IsShowPassword ? 'text' : 'password'}
                        className="form-control"
                        name="password"
                        minLength="8"
                        maxLength="12"
                        onChange={(e) => handleInputChanges(e, 'password')}
                        placeholder="Password"
                        autoComplete="new-password"
                      />
                      <span
                        className={
                          IsShowPassword
                            ? 'fa-eye fa fa-fw field-icon toggle-password'
                            : 'fa-eye-slash fa fa-fw field-icon toggle-password'
                        }
                        onClick={() => setIsShowPassword((prevState) => !prevState)}
                      ></span>
                      {urlParams.id !== undefined
                        ? validator.current.message('Password', Inputs.password, 'min:8|max:12', {
                            className: 'error'
                          })
                        : validator.current.message(
                            'Password',
                            Inputs.password,
                            `required|min:8|max:12`,
                            { className: 'error' }
                          )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Confirm Password</label>
                      <input
                        type={IsShowConfirmPassword ? 'text' : 'password'}
                        className="form-control"
                        name="confirm_password"
                        onChange={(e) => handleInputChanges(e, 'confirm_password')}
                        placeholder="Confirm Password"
                        minLength="8"
                        maxLength="12"
                      />
                      <span
                        className={
                          IsShowConfirmPassword
                            ? 'fa-eye fa fa-fw field-icon toggle-password'
                            : 'fa-eye-slash fa fa-fw field-icon toggle-password'
                        }
                        onClick={() => setIsShowConfirmPassword((prevState) => !prevState)}
                      ></span>
                      {urlParams.id !== undefined && Inputs.password.length < 1
                        ? validator.current.message(
                            'Confirm Password',
                            Inputs.confirm_password,
                            `min:8|max:12|in:${Inputs.password}`,
                            {
                              className: 'error',
                              messages: {
                                in: 'Not matched with password!'
                              }
                            }
                          )
                        : validator.current.message(
                            'Confirm Password',
                            Inputs.confirm_password,
                            `required|min:8|max:12|in:${Inputs.password}`,
                            {
                              className: 'error',
                              messages: {
                                in: 'Not matched with password!'
                              }
                            }
                          )}
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <label>Role </label>
                      {Roles.length > 0 && (
                        <Select
                          className="dropdown w-auto"
                          placeholder="Select Option"
                          value={Roles.filter((obj) => Inputs.roleids?.includes(obj.value))}
                          options={Roles}
                          onChange={(e) => handleInputChanges(e, 'roleids')}
                          isMulti
                          isClearable
                        />
                      )}
                      {validator.current.message('Role', Inputs.roleids, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="is_active"
                            onChange={(e) => handleInputChanges(e, 'is_active')}
                            id="EnableUser"
                            checked={Inputs.is_active}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableUser"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      ref={submitbtnRef}
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/users"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddUser
